export const authAction = {
  setCurrentUser: (state, action) => {
    state.currentUser = action.payload;
  },
};
